import script from "./CookieCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./CookieCheckbox.vue?vue&type=style&index=0&id=27350214&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27350214"]])

export default __exports__